import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAccountSettingsStore = defineStore(
  'accountSettings',
  () => {
    const accountId = ref('')
    const isClientUser = ref(false)
    const sessionToken = ref('')
    const role = ref('')
    const accountSettings = ref<IAccountSettings | null>(null)

    const setAccountSettings = (settings: IAccountSettings | null) => {
      setAccountId(settings?.juid ?? '')
      accountSettings.value = settings
    }

    const setIsClientUser = (value: boolean) => {
      isClientUser.value = value
    }

    const setSessionToken = (token: string) => {
      sessionToken.value = token
    }

    const setRole = (userRole: string) => {
      role.value = userRole
      console.log('Coupon Builder Admin: Set user role:', userRole)
    }

    const getAccountSettings = (): any => {
      return accountSettings.value
    }

    const setAccountId = (newAccountId: string) => {
      accountId.value = newAccountId
    }

    return {
      accountId,
      isClientUser,
      sessionToken,
      role,

      getAccountSettings,
      setAccountSettings,
      setIsClientUser,
      setSessionToken,
      setRole,
    }
  },
  {
    persist: {
      storage: sessionStorage,
      paths: ['accountId'],
    } as any,
  },
)
